<div class="dialog-container" [formGroup]="supportForm">
  <div class="dialog-header">
    <span>GSD Support</span>
    <button class="close-btn" (click)="onClose()">×</button>
  </div>

  <div class="form-group">
    <label for="subject">Subject</label>
    <input type="text" id="subject" formControlName="subject" placeholder="E.g, Need to have one more domain..."
      autocomplete="off">
  </div>

  <div class="form-group">
    <label for="comment" class="label-with-icon">
      Comments
      <sup>
        <span class="material-symbols-outlined info-icon"
          title="For Git access or GSD suggestions, please add a subject and brief comment.">
          info
        </span>
      </sup>
    </label>
    <textarea id="comment" formControlName="comment" placeholder="Enter comments here..."></textarea>
  </div>

  <div class="row m-0">
    <div class="col-md-8 pl-md-0 pb-20">
      <div class="custom_paragraph">
        <div class="field_heading"><span class="secondaryInfo">Attachment</span></div>
        <div class="dropzone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
          <div class="text-wrapper">
            <div class="upload_section">
              <input #file type="file" class="form-control" name="Screenshot" id="file"
                (change)="onFileChange($event.target.files)" [accept]="allowedLogoExtentions">
              <label for="file">
                <div class="browse-div">
                  <i class="msicon">
                    <span class="material-symbols-rounded" style="font-size: 36px;">
                      backup
                    </span>
                  </i>
                  <div class="custom_paragraph"> Drag your file(s) or <span class="link">browse</span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="logo" class="form-control fileUpload field_value">
        <div class="avatar"><span class="material-symbols-outlined fs-18 add-circle"> description
          </span>
        </div>
        <div class="file-info">
          <span class="title">{{ getTruncatedFileName(logo.name, 20) }}</span>
        </div>
        <a (click)="RemoveLogo()" class="icon"><span class="material-symbols-outlined fs-18 deleteIcon">
            delete
          </span></a>
      </div>
    </div>
  </div>

  <button class="submit-btn" [disabled]="supportForm.invalid || isSubmitting" (click)="submit()">Submit</button>
</div>